const Mock  = require('mockjs')

Mock.setup({
  timeout: 5000
})

const modulesFiles = require.context("./modules",true,/\.js$/)
modulesFiles.keys().forEach((item)=> {
  console.log(item)
})
const modules = modulesFiles.keys().reduce((modules,modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
},{})

export default {
  modules
}



// WEBPACK FOOTER //
// ./src/mock/index.js